// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader_header__0cxIC","nakedHeader":"PageHeader_nakedHeader__xW5Su","headerVideo":"PageHeader_headerVideo__l7PFp","video":"PageHeader_video__LXKmV"};